import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { getDistance, getRangeMax, getRangeValue } from "tsparticles-engine";
import { applyDistance, getProximitySpeedFactor, move as _move, spin } from "./Utils";
var diffFactor = 2;
export var BaseMover = /*#__PURE__*/function () {
  function BaseMover() {
    _classCallCheck(this, BaseMover);

    this._initSpin = function (particle) {
      var _spinOptions$position;

      var container = particle.container,
          options = particle.options,
          spinOptions = options.move.spin;

      if (!spinOptions.enable) {
        return;
      }

      var spinPos = (_spinOptions$position = spinOptions.position) !== null && _spinOptions$position !== void 0 ? _spinOptions$position : {
        x: 50,
        y: 50
      },
          spinCenter = {
        x: spinPos.x / 100 * container.canvas.size.width,
        y: spinPos.y / 100 * container.canvas.size.height
      },
          pos = particle.getPosition(),
          distance = getDistance(pos, spinCenter),
          spinAcceleration = getRangeValue(spinOptions.acceleration);
      particle.retina.spinAcceleration = spinAcceleration * container.retina.pixelRatio;
      particle.spin = {
        center: spinCenter,
        direction: particle.velocity.x >= 0 ? "clockwise" : "counter-clockwise",
        angle: particle.velocity.angle,
        radius: distance,
        acceleration: particle.retina.spinAcceleration
      };
    };
  }

  _createClass(BaseMover, [{
    key: "init",
    value: function init(particle) {
      var options = particle.options,
          gravityOptions = options.move.gravity;
      particle.gravity = {
        enable: gravityOptions.enable,
        acceleration: getRangeValue(gravityOptions.acceleration),
        inverse: gravityOptions.inverse
      };

      this._initSpin(particle);
    }
  }, {
    key: "isEnabled",
    value: function isEnabled(particle) {
      return !particle.destroyed && particle.options.move.enable;
    }
  }, {
    key: "move",
    value: function move(particle, delta) {
      var _particle$retina, _particle$retina$move, _particle$retina2, _particle$retina2$mov, _particle$retina$maxS;

      var particleOptions = particle.options,
          moveOptions = particleOptions.move;

      if (!moveOptions.enable) {
        return;
      }

      var container = particle.container,
          pxRatio = container.retina.pixelRatio,
          slowFactor = getProximitySpeedFactor(particle),
          baseSpeed = ((_particle$retina$move = (_particle$retina = particle.retina).moveSpeed) !== null && _particle$retina$move !== void 0 ? _particle$retina$move : _particle$retina.moveSpeed = getRangeValue(moveOptions.speed) * pxRatio) * container.retina.reduceFactor,
          moveDrift = (_particle$retina2$mov = (_particle$retina2 = particle.retina).moveDrift) !== null && _particle$retina2$mov !== void 0 ? _particle$retina2$mov : _particle$retina2.moveDrift = getRangeValue(particle.options.move.drift) * pxRatio,
          maxSize = getRangeMax(particleOptions.size.value) * pxRatio,
          sizeFactor = moveOptions.size ? particle.getRadius() / maxSize : 1,
          moveSpeed = baseSpeed * sizeFactor * slowFactor * (delta.factor || 1) / diffFactor,
          maxSpeed = (_particle$retina$maxS = particle.retina.maxSpeed) !== null && _particle$retina$maxS !== void 0 ? _particle$retina$maxS : container.retina.maxSpeed;

      if (moveOptions.spin.enable) {
        spin(particle, moveSpeed);
      } else {
        _move(particle, moveOptions, moveSpeed, maxSpeed, moveDrift, delta);
      }

      applyDistance(particle);
    }
  }]);

  return BaseMover;
}();